
// Aux file to bundle everything together, including the optional dependencies
// for protobuf tiles

import {} from 'whatwg-fetch'

import {} from 'pbf';
import {VectorTile} from '@mapbox/vector-tile';

import {} from './Leaflet.VectorGrid.js';
import {} from './Leaflet.VectorGrid.Protobuf.js';
import {} from './Leaflet.VectorGrid.Slicer.js';
import {} from './Leaflet.Renderer.Canvas.Tile.js';
import {} from './Leaflet.Renderer.SVG.Tile.js';

